export default __webpack_public_path__ + "static/media/our_breakfast@2x.7a67e0e3.png";